var extensionVS = `
`;

export { extensionVS as default };
